// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"270":"734addee","455":"8524f7ec","611":"0ec66899","836":"148eac84","862":"d09d81e3","977":"1336d7dd"}[chunkId] + ".chunk.js";
};